import {
    API_ACTIVATION_STATE_ACTIVE,
    API_ACTIVATION_STATE_INACTIVE,
    API_ACTIVATION_STATE_PENDING_ACTIVATION,
    API_ACTIVATION_STATE_PENDING_CANCELLATION,
    type ApiActivationState,
} from './activation.types';
import { ActivationState } from '../../utilities/types';
import { UnreachableCaseError } from '../../common/utils/typescriptUtil';

export function convertApiActivationState(apiState: ApiActivationState): ActivationState {
    switch (apiState) {
        case API_ACTIVATION_STATE_ACTIVE:
            return ActivationState.ACTIVE;
        case API_ACTIVATION_STATE_INACTIVE:
            return ActivationState.INACTIVE;
        case API_ACTIVATION_STATE_PENDING_ACTIVATION:
            return ActivationState.PENDING_ACTIVATION;
        case API_ACTIVATION_STATE_PENDING_CANCELLATION:
            return ActivationState.PENDING_CANCELLATION;
        default:
            throw new UnreachableCaseError(apiState);
    }
}
